// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  THideOfferWebsiteRequest,
  THideOfferWebsiteModel,
  IMappers,
  THideOfferWebsiteResponse_,
  THideOfferWebsiteResponse,
  THideOfferWebsiteResponse_1,
  THideOfferWebsiteResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createHideOfferWebsiteModel(parameters: THideOfferWebsiteRequest): THideOfferWebsiteModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'hidden-objects',
    pathApi: '/v1/hide-offer-website/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IHideOfferWebsiteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: THideOfferWebsiteRequest;
}

export async function fetchHideOfferWebsite<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IHideOfferWebsiteOptions<TResponse200, TResponse400>): Promise<
  THideOfferWebsiteResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createHideOfferWebsiteModel(parameters),
    config,
  )) as FetchResponse<THideOfferWebsiteResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as THideOfferWebsiteResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as THideOfferWebsiteResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as THideOfferWebsiteResponse;
}
